(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["9mm-v7-cart"]) return;
  try {
    
  (() => {
    const initializeCart = root => {
      if (!root || root.dataset.v7CartReady) return;
      root.dataset.v7CartReady = 'true';
      const inputs = [...root.querySelectorAll('input[name="updates[]"]')];
      const pending = root.querySelector('[data-v7-cart-pending]');
      const refresh = () => {
        const dirty = inputs.some(input => input.value !== input.dataset.originalQuantity);
        root.classList.toggle('is-dirty', dirty);
        if (pending) pending.hidden = !dirty;
        inputs.forEach(input => {
          const group = input.closest('[data-v7-cart-quantity]');
          const value = Number(input.value);
          const minimum = Number(input.min) || 1;
          const maximum = input.max ? Number(input.max) : Infinity;
          group.querySelector('[data-v7-cart-decrease]').disabled = !Number.isFinite(value) || value <= minimum;
          group.querySelector('[data-v7-cart-increase]').disabled = Number.isFinite(value) && value >= maximum;
        });
      };
      inputs.forEach(input => {
        const group = input.closest('[data-v7-cart-quantity]');
        const decrease = group.querySelector('[data-v7-cart-decrease]');
        const increase = group.querySelector('[data-v7-cart-increase]');
        decrease.hidden = false;
        increase.hidden = false;
        const change = direction => {
          const minimum = Number(input.min) || 1;
          const maximum = input.max ? Number(input.max) : Infinity;
          const step = Number(input.step) || 1;
          const current = input.valueAsNumber;
          const value = Number.isFinite(current) ? current : minimum;
          const offset = (value - minimum) / step;
          const next = minimum + (direction > 0 ? Math.floor(offset) + 1 : Math.ceil(offset) - 1) * step;
          input.value = String(Math.min(maximum, Math.max(minimum, next)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        };
        decrease.addEventListener('click', () => change(-1));
        increase.addEventListener('click', () => change(1));
        input.addEventListener('input', refresh);
        input.addEventListener('change', refresh);
      });
      refresh();
    };
    document.querySelectorAll('[data-v7-cart]').forEach(initializeCart);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-v7-cart]').forEach(initializeCart));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9mm-v7-collection"]) return;
  try {
    
  (() => {
    const initialize = scope => {
      scope.querySelectorAll('[data-v7-catalog]').forEach(root => {
        if (root.dataset.v7CatalogReady) return;
        root.dataset.v7CatalogReady = 'true';
        const chapters = Array.from(root.querySelectorAll('[data-v7-catalog-category]'));
        const controls = root.querySelector('[data-v7-catalog-filters]');
        const buttons = Array.from(root.querySelectorAll('[data-v7-catalog-filter]'));
        const status = root.querySelector('[data-v7-catalog-status]');
        const navigation = root.querySelector('.v7-catalog__navigation');
        const content = root.querySelector('.v7-catalog__content');
        if (!controls || !status || !navigation || !content) return;
        const counts = new Map(chapters.map(chapter => [chapter.dataset.v7CatalogCategory, Number(chapter.dataset.v7CatalogCount) || 0]));
        const total = chapters.reduce((sum, chapter) => sum + Number(chapter.dataset.v7CatalogCount || 0), 0);
        root.querySelectorAll('[data-v7-filter-count]').forEach(node => { node.textContent = node.dataset.v7FilterCount === 'all' ? total : counts.get(node.dataset.v7FilterCount) || 0; });
        const apply = category => {
          const selectedButton = buttons.find(button => button.dataset.v7CatalogFilter === category);
          if (selectedButton?.getAttribute('aria-pressed') === 'true') return;
          const reposition = content.getBoundingClientRect().top < navigation.getBoundingClientRect().bottom - 16;
          let count = 0;
          chapters.forEach(chapter => {
            const show = category === 'all' || chapter.dataset.v7CatalogCategory === category;
            chapter.hidden = !show;
            if (show) count += Number(chapter.dataset.v7CatalogCount || 0);
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.v7CatalogFilter === category)));
          status.textContent = `${count} ${count === 1 ? root.dataset.productSingular : root.dataset.productPlural}`;
          if (reposition) requestAnimationFrame(() => {
            if (!root.isConnected) return;
            const firstResult = chapters.find(chapter => !chapter.hidden);
            if (!firstResult) return;
            const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--v7-header-height')) || 80;
            const target = Math.max(0, window.scrollY + firstResult.getBoundingClientRect().top - headerHeight - navigation.getBoundingClientRect().height);
            if (Math.abs(window.scrollY - target) > 8) window.scrollTo({ top: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
        };
        buttons.forEach(button => {
          const category = button.dataset.v7CatalogFilter;
          if (category !== 'all' && !counts.has(category)) button.disabled = true;
          button.addEventListener('click', () => apply(category));
        });
        root.querySelector('[data-v7-catalog-fallback]').hidden = true;
        controls.hidden = false;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9mm-v7-header"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('v7-navigation'))customElements.define('v7-navigation',class extends HTMLElement{
    connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.header=this.querySelector('[data-v7-header]');this.dialog=this.querySelector('dialog');this.opener=this.querySelector('[data-v7-open]');this.onScroll=()=>this.header.classList.toggle('is-scrolled',window.scrollY>32);this.onScroll();window.addEventListener('scroll',this.onScroll,{passive:true,signal});this.opener.addEventListener('click',()=>{this.dialog.showModal();this.opener.setAttribute('aria-expanded','true');this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden'},{signal});this.querySelector('[data-v7-close]').addEventListener('click',()=>this.dialog.close(),{signal});this.dialog.addEventListener('close',()=>{this.opener.setAttribute('aria-expanded','false');document.body.style.overflow=this.previousOverflow||'';this.opener.focus()},{signal});this.dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>this.dialog.close(),{signal}));}
    disconnectedCallback(){this.abort?.abort();if(this.dialog?.open){document.body.style.overflow=this.previousOverflow||'';this.dialog.close();}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9mm-v7-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.v7Ready) return;
      root.dataset.v7Ready = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      const dataSaver = Boolean(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
      const cleanups = [];
      const panels = Array.from(root.querySelectorAll('[data-v7-product]'));
      root.querySelectorAll('[data-v7-open-clip]').forEach(button => {
        const dialog = document.getElementById(button.dataset.v7OpenClip);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const video = dialog.querySelector('video');
        button.hidden = false;
        button.addEventListener('click', () => { dialog.showModal(); video.play().catch(() => {}); });
        dialog.querySelector('[data-v7-close-clip]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { video.pause(); button.focus(); });
        dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
        cleanups.push(() => { video.pause(); if (dialog.open) dialog.close(); });
      });
      let frame = 0;
      const updateCanMotion = () => {
        frame = 0;
        if (reduced.matches || dataSaver) return;
        panels.forEach(panel => {
          const box = panel.getBoundingClientRect();
          if (box.bottom < 0 || box.top > window.innerHeight) return;
          const shift = Math.max(-22, Math.min(22, ((window.innerHeight / 2 - box.top - box.height / 2) / window.innerHeight) * 36));
          panel.style.setProperty('--v7-can-shift', shift.toFixed(1) + 'px');
        });
      };
      const onScroll = () => { if (!frame && !reduced.matches && !dataSaver) frame = requestAnimationFrame(updateCanMotion); };
      if ('IntersectionObserver' in window && !reduced.matches && !dataSaver) {
        root.classList.add('v7-home--motion');
        const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
        }), { threshold: 0.06 });
        root.querySelectorAll('[data-v7-reveal]').forEach(element => revealObserver.observe(element));
        cleanups.push(() => revealObserver.disconnect());
        window.addEventListener('scroll', onScroll, { passive: true });
        cleanups.push(() => window.removeEventListener('scroll', onScroll));
        updateCanMotion();
      }
      const film = root.querySelector('[data-v7-film]');
      if (film) {
        const video = film.querySelector('video');
        const play = film.querySelector('[data-v7-film-play]');
        play.hidden = false;
        const showNativeControls = () => { play.hidden = true; video.controls = true; };
        play.addEventListener('click', () => { showNativeControls(); video.focus(); video.play().catch(() => {}); });
        video.addEventListener('play', showNativeControls);
        video.addEventListener('error', showNativeControls);
        const pauseHiddenFilm = () => { if (document.hidden) video.pause(); };
        document.addEventListener('visibilitychange', pauseHiddenFilm);
        cleanups.push(() => document.removeEventListener('visibilitychange', pauseHiddenFilm));
        if ('IntersectionObserver' in window) {
          const filmObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) video.pause(); }), { threshold: 0 });
          filmObserver.observe(film);
          cleanups.push(() => { filmObserver.disconnect(); video.pause(); });
        }
      }
      const ambient = root.querySelector('[data-v7-ambient]');
      const ambientToggle = root.querySelector('[data-v7-ambient-toggle]');
      let ambientVideo;
      let ambientVisible = false;
      let manuallyPaused = false;
      if (ambient && ambientToggle) {
        ambientVideo = ambient.querySelector('video');
        ambientVideo.muted = true;
        const updateAmbient = () => {
          const playing = !ambientVideo.paused;
          ambient.classList.toggle('is-playing', playing);
          ambientToggle.setAttribute('aria-pressed', String(playing));
          const label = playing ? ambientToggle.dataset.pauseLabel : ambientToggle.dataset.playLabel;
          ambientToggle.setAttribute('aria-label', label);
          ambientToggle.querySelector('[data-v7-motion-label]').textContent = label;
        };
        const tryAutoplay = () => {
          if (ambientVisible && !document.hidden && !reduced.matches && !dataSaver && !manuallyPaused && ambient.hasAttribute('data-autoplay')) ambientVideo.play().catch(updateAmbient);
          else ambientVideo.pause();
        };
        ambientToggle.addEventListener('click', () => {
          if (ambientVideo.paused) { manuallyPaused = false; ambientVideo.play().catch(updateAmbient); }
          else { manuallyPaused = true; ambientVideo.pause(); }
        });
        ambientVideo.addEventListener('play', updateAmbient);
        ambientVideo.addEventListener('pause', updateAmbient);
        if ('IntersectionObserver' in window) {
          const ambientObserver = new IntersectionObserver(entries => entries.forEach(entry => { ambientVisible = entry.isIntersecting; tryAutoplay(); }), { threshold: 0.2 });
          ambientObserver.observe(root.querySelector('.v7-home__hero'));
          cleanups.push(() => ambientObserver.disconnect());
        }
        const onVisibility = () => { if (document.hidden) { ambientVideo.pause(); film?.querySelector('video')?.pause(); } else tryAutoplay(); };
        document.addEventListener('visibilitychange', onVisibility);
        cleanups.push(() => { document.removeEventListener('visibilitychange', onVisibility); ambientVideo.pause(); });
      }
      const onReducedChange = () => {
        if (reduced.matches) { root.classList.remove('v7-home--motion'); panels.forEach(panel => panel.style.removeProperty('--v7-can-shift')); ambientVideo?.pause(); }
      };
      reduced.addEventListener('change', onReducedChange);
      cleanups.push(() => reduced.removeEventListener('change', onReducedChange));
      root.v7Cleanup = () => { cleanups.forEach(cleanup => cleanup()); if (frame) cancelAnimationFrame(frame); };
    };
    document.querySelectorAll('[data-v7-home]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => { if (event.target.matches('[data-v7-home]')) initialize(event.target); event.target.querySelectorAll('[data-v7-home]').forEach(initialize); });
    document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-v7-home]').forEach(root => root.v7Cleanup?.()); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9mm-v7-product"]) return;
  try {
    
  (() => {
    const init = scope => {
      scope.querySelectorAll('[data-v7-product]').forEach(root => {
        if (root.dataset.v7Ready) return;
        root.dataset.v7Ready = 'true';
        const select = root.querySelector('[data-v7-variant]');
        const quantity = root.querySelector('[data-v7-quantity]');
        const button = root.querySelector('[data-v7-add]');
        if (!select || !quantity || !button) return;
        select.addEventListener('change', () => {
          const variant = select.selectedOptions[0];
          const available = variant.dataset.available === 'true';
          root.querySelector('[data-v7-price]').textContent = variant.dataset.price;
          const compare = root.querySelector('[data-v7-compare]');
          compare.textContent = variant.dataset.compare;
          compare.hidden = !variant.dataset.compare;
          root.querySelector('[data-v7-stock]').textContent = available ? root.dataset.stockLabel : root.dataset.soldLabel;
          button.disabled = !available;
          button.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
          const minimum = Number(variant.dataset.min) || 1;
          const increment = Number(variant.dataset.step) || 1;
          quantity.min = minimum;
          quantity.step = increment;
          if (variant.dataset.max) quantity.max = variant.dataset.max;
          else quantity.removeAttribute('max');
          let value = Math.max(minimum, Number(quantity.value) || minimum);
          value = minimum + Math.ceil((value - minimum) / increment) * increment;
          if (quantity.max) value = Math.min(value, Number(quantity.max));
          quantity.value = value;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', select.value);
          history.replaceState({}, '', url);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["9mm-v7-universe"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeEditorial = root => {
      if (!root || root.dataset.editorialReady) return;
      root.dataset.editorialReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanups = [];
      if ('IntersectionObserver' in window && !reduced.matches && !navigator.connection?.saveData) {
        root.classList.add('is-motion');
        const reveal = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); } }), { threshold: .05 });
        root.querySelectorAll('[data-v7-editorial-reveal]').forEach(element => reveal.observe(element));
        cleanups.push(() => reveal.disconnect());
      }
      root.querySelectorAll('[data-v7-editorial-film]').forEach(container => {
        const video = container.querySelector('video');
        const button = container.querySelector('[data-v7-editorial-play]');
        if (!video || !button) return;
        button.hidden = false;
        const exposePlayer = () => { button.hidden = true; video.controls = true; };
        button.addEventListener('click', () => { root.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }); exposePlayer(); video.focus(); video.play().catch(() => {}); });
        video.addEventListener('play', exposePlayer);
        video.addEventListener('error', exposePlayer);
        if ('IntersectionObserver' in window) { const visibility = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) video.pause(); })); visibility.observe(video); cleanups.push(() => visibility.disconnect()); }
        cleanups.push(() => video.pause());
      });
      const pauseHidden = () => { if (document.hidden) root.querySelectorAll('video').forEach(video => video.pause()); };
      const stopMotion = () => { if (reduced.matches) root.classList.remove('is-motion'); };
      document.addEventListener('visibilitychange', pauseHidden);
      reduced.addEventListener('change', stopMotion);
      cleanups.push(() => { document.removeEventListener('visibilitychange', pauseHidden); reduced.removeEventListener('change', stopMotion); });
      root.editorialCleanup = () => cleanups.forEach(cleanup => cleanup());
    };
    document.querySelectorAll('[data-v7-editorial]').forEach(initializeEditorial);
    document.addEventListener('shopify:section:load', event => { if (event.target.matches('[data-v7-editorial]')) initializeEditorial(event.target); event.target.querySelectorAll('[data-v7-editorial]').forEach(initializeEditorial); });
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-v7-editorial]').forEach(root => root.editorialCleanup?.()));
  })();

  } catch(e) { console.error(e); }
})();
})();
